import React from "react";
import { Button, Checkbox } from "antd";
import { Company } from "common/interfaces";
import { Link } from "react-router-dom";
import { UTCToJapanTime } from "common/helper/time.helper";
import { CompanyInfoStatusEnum } from "common/enums/CompanyInfoStatus.enum";
import { UserTypeEnum, UserTypeToLabel } from "common/enums/UserType.enum";
import { companyInfoStatusMap } from "common/helper/text.helper";

interface CompanyItemProps<T extends Company> {
  company: T;
  checked: boolean;
  onSelect: (code: string, checked: boolean) => void;
}

export function CompanyItem<T extends Company>({
  company,
  checked,
  onSelect,
}: CompanyItemProps<T>) {
  const timeJapan = UTCToJapanTime(company.created_at);

  return (
    <div className="self-stretch bg-white rounded-md flex flex-col justify-start items-start overflow-hidden">
      <div
        data-プロパティ1="base + checkbox"
        className="self-stretch min-h-10 px-12 py-2.5 relative bg-primary inline-flex justify-center items-center gap-2.5"
      >
        <div className="flex-1 text-center justify-start text-white text-sm font-bold font-['Noto_Sans_JP'] leading-snug">
          申請ID #{company.code}
        </div>
        <div
          data-プロパティ1="active - border"
          className="w-7 h-7 py-[3px] left-[10px] top-[6px] absolute bg-primary rounded-md inline-flex flex-col justify-center items-center gap-2.5 overflow-hidden"
        >
          <Checkbox
            checked={checked}
            onChange={(e) => onSelect(company.code, e.target.checked)}
          />
        </div>
      </div>
      <div className="self-stretch min-h-10 p-5 bg-white rounded-bl-md rounded-br-md border-l border-r border-b border-neutral-300 flex flex-col justify-center items-center gap-5">
        <div className="self-stretch inline-flex justify-start items-start gap-3.5 flex-wrap content-start">
          <div className="min-w-32 inline-flex flex-col justify-start items-start gap-[3px]">
            <div className="self-stretch justify-start text-slate-400 text-[13px] font-normal font-['Noto_Sans_JP'] leading-tight">
              法人名
            </div>
            <div className="self-stretch justify-start text-black text-[15px] font-normal font-['Noto_Sans_JP'] leading-normal">
              {company.company_name}
            </div>
          </div>
          <div className="flex-1 min-w-32 inline-flex flex-col justify-start items-start gap-[3px]">
            <div className="self-stretch justify-start text-slate-400 text-[13px] font-normal font-['Noto_Sans_JP'] leading-tight">
              担当者名
            </div>
            <div className="self-stretch justify-start text-black text-[15px] font-normal font-['Noto_Sans_JP'] leading-normal">
              {company.contact_last_name}
            </div>
          </div>
          <div className="flex-1 min-w-32 inline-flex flex-col justify-start items-start gap-[3px]">
            <div className="self-stretch justify-start text-slate-400 text-[13px] font-normal font-['Noto_Sans_JP'] leading-tight">
              ユーザー種別
            </div>
            <div className="self-stretch justify-start text-black text-[15px] font-normal font-['Noto_Sans_JP'] leading-normal">
              {UserTypeToLabel[company.type as UserTypeEnum]}
            </div>
          </div>
          <div className="flex-1 min-w-32 inline-flex flex-col justify-start items-start gap-[3px]">
            <div className="self-stretch justify-start text-slate-400 text-[13px] font-normal font-['Noto_Sans_JP'] leading-tight">
              ステータス
            </div>
            <div className="self-stretch justify-start text-black text-[15px] font-normal font-['Noto_Sans_JP'] leading-normal">
              {companyInfoStatusMap[company.status]}
            </div>
          </div>
          <div className="flex-1 h-12 min-w-32 inline-flex flex-col justify-start items-start gap-[3px]">
            <div className="self-stretch justify-start text-slate-400 text-[13px] font-normal font-['Noto_Sans_JP'] leading-tight">
              最終更新
            </div>
            <div className="self-stretch justify-start text-black text-[15px] font-normal font-['Noto_Sans_JP'] leading-normal">
              {`${timeJapan.year}/${timeJapan.month}/${timeJapan.day} ${timeJapan.hour}:${timeJapan.minute}`}
            </div>
          </div>
        </div>
        <Link to={`/admin/review-company/${company.code}`} className="w-full">
          <Button
            block
            type="primary"
            htmlType="button"
            className="w-full min-h-[50px] bg-primary-light text-primary text-[16px] font-bold"
          >
            {company.status === CompanyInfoStatusEnum.REJECTED
              ? "否認理由を確認する"
              : "審査へ進む"}
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default CompanyItem;
